import apiAthleteResult from '@/api/athlete-result'

const state = {
  data: [],
  isLoading: false,
  error: null,
  total: 0
}

export const mutationTypes = {
  getAthleteResultStart:
    '[athlete result by id] Get athlete result by id start',
  getAthleteResultSuccess:
    '[athlete result by id] Get athlete result by id success',
  getAthleteResultFailure:
    '[athlete result by id] Get athlete result by id failure'
}

export const actionTypes = {
  getAthleteResult: '[athlete result by id] Get athlete by id result'
}

const mutations = {
  [mutationTypes.getAthleteResultStart](state) {
    state.isLoading = true
    state.error = null
    state.data = []
  },

  [mutationTypes.getAthleteResultSuccess](state, payload) {
    state.data = payload.data ? payload.data : payload
    state.total = payload.total ? payload.total : 0
    state.isLoading = false
  },

  [mutationTypes.getAthleteResultFailure](state, payload) {
    state.isLoading = false
    state.error = payload
  }
}

const actions = {
  [actionTypes.getAthleteResult](context, {params}) {
    context.commit(mutationTypes.getAthleteResultStart)
    return new Promise(resolve => {
      apiAthleteResult
        .getAthletesResultById(params)
        .then(response => {
          const result = response.data ? response.data : response
          context.commit(mutationTypes.getAthleteResultSuccess, response)
          resolve(result)
        })
        .catch(error => {
          context.commit(mutationTypes.getAthleteResultFailure, error)
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
